<ng-casto-project-title [title]="configuration.title" (titleChange)="onTitleChange($event)"></ng-casto-project-title>

<div class="elcia-loader" *ngIf="loader">
  <ng-casto-loader></ng-casto-loader>
</div>

<div id="elciaContainer"></div>
